import { baseUrl, isSignedIn, getHeaders } from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

export async function QuotationGraphicServicesGetCarImage() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetRepairGraphicVehicleImage`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationGraphicServicesGetMainGroupImage(payload) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetRepairGraphicMainGroupImage`;

    return axios.get(urlApi, { params: payload, ...getHeaders(true) });
}

export async function QuotationGraphicServicesGetSubGroupQuals(payload) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetRepairGraphicSubGroupQuals`;

    return axios.get(urlApi, { params: payload, ...getHeaders(true) });
}

export async function QuotationGraphicServicesGetSubGroupWithQualImage(payload) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetRepairGraphicSubGroupWithQualImage`;

    return axios.get(urlApi, { params: payload, ...getHeaders(true) });
}

export async function QuotationGraphicServicesGetRepairGraphicList() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetRepairGraphicList`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationGraphicServicesGetWorkStep(mapId) {
    await isSignedIn();

    const query = queryFilter({ itemMpId: mapId });
    const urlApi = `${baseUrl}/Quotation/GetRepairGraphicWorkSteps${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function QuotationGraphicServicesGetPreSelectedData(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Quotation/GetGraphicPreSelectedData`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function QuotationGraphicServicesGetByStep(stepId, id) {
    await isSignedIn();

    const url = "/Quotation/repair/graphic/vehicle/html";
    const urlApi = `${baseUrl}${url}`;
    const body = {
        stepId,
        id,
        stepUrl: `${window.location.origin}${url}/step/${+stepId + 1}?id=`,
    };

    return axios.post(urlApi, body, getHeaders(true));
}
